/**
 * 实时发运监控看板 — POST /api/produce/kanban/real-time-shipment-monitor
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/real-time-shipment-monitor'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchRealTimeShipmentMonitor(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
